import MyTabs from '../../../components/MyTabs';
import Establishment from './Establishment';
import Preface from './Preface';
// import Highlights from './Highlights';
import Teams from './Teams';
// import Specifications from './Specifications';

const Introduction = (props) => {
  
    const tabs = [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "establishment", title: "Establishment" , Component: Establishment},
        { id: "team", title: "Team" , Component: Teams},
        //Todo: Need to add highlights when data is finalized
        // { id: "highlights", title: "Highlights" , Component: Highlights},
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default Introduction;